import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {Headers, Http} from '@angular/http';
import {environment} from '../environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})
export class LoginComponent {
    errorMessage: string;

    constructor(public router: Router, public http: Http) {
    }

    login(event, username, password) {
        event.preventDefault();

        const contentHeaders = new Headers();
        contentHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

        const urlSearchParams = new URLSearchParams();
        urlSearchParams.append('username', username);
        urlSearchParams.append('password', password);
        const body = urlSearchParams.toString();

        this.http.post(environment.apiUrl + '/backend/login', body, {headers: contentHeaders})
            .subscribe(
                response => {
                    localStorage.setItem('token', response.json().token);
                    this.router.navigate(['tilldelning']);
                },
                error => {
                    this.errorMessage = error.text();
                }
            );
    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/login.component.ts